const EyeOffIcon = ({ className = "h-5 w-5", onClick }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={`cursor-pointer text-navy-700 dark:text-white ${className}`}
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
      onClick={onClick}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.878 9.878L3 3m6.878 6.878L21 21"
      />
    </svg>
  );
};

export default EyeOffIcon;
